import httpClient from '../httpClient';

const getAll = async () => {
  return await httpClient.get(
    `${process.env.REACT_APP_API_HOST}/job_type/?page[size]=1000&sort=nombre`,
  );
};

export { getAll };
